/* KLARHEIT 2027 — Scroll-Reveals (from design handoff reveal.js).
   Elements fade in on first viewport entry. Stagger 80ms per element
   within a section (max 400ms), 0.85s, translateY(24px) -> 0.
   Gated on prefers-reduced-motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  requestAnimationFrame(function () { requestAnimationFrame(init); });

  function init() {
    var sels = [
      '.k27.sec > *',
      '.k27.proofbar', '.k27 .imgbreak',
      '.k27 .pdp-top > .gal', '.k27 .pdp-top > .buybox > *',
      '.k27 .final-over > *', '.k27 .moment-over > *',
      '.k27 .fgrid > .fcard', '.k27 .steps > .step', '.k27 .wsteps > .wstep',
      '.k27 .loox-grid > .loox-card', '.k27 .ch-grid > .ch-card',
      '.k27 .r-cards > .r-card', '.k27 .timeline > .tl-item', '.k27 .fw-list > li'
    ].join(', ');

    var all = Array.prototype.slice.call(document.querySelectorAll(sels));
    var els = all.filter(function (el) {
      return !all.some(function (o) { return o !== el && el.contains(o); });
    });

    /* Heroes + PDP-Top haben eine eigene Lade-Choreografie (CSS-Keyframes
       in k27-base.css) — aus dem Scroll-Reveal ausnehmen, sonst animiert
       beides uebereinander bzw. .rv (opacity 0) gewinnt nach der Animation. */
    els = els.filter(function (el) {
      return !el.closest('.k27.hero, .k27.about-hero, .k27.pdp-top, .k27.qz-page');
    });

    var counters = new Map();
    els.forEach(function (el) {
      el.classList.add('rv');
      var p = el.parentNode;
      var i = counters.get(p) || 0;
      counters.set(p, i + 1);
      el.style.setProperty('--rvd', Math.min(i * 80, 400) + 'ms');
    });

    var pending = els.slice();
    function check() {
      if (!pending.length) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      pending = pending.filter(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.93 && r.bottom > 0) {
          el.classList.add('on');
          return false;
        }
        return true;
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; check(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
    window.addEventListener('load', check);
    setTimeout(check, 600);
  }
})();

/* Chapter numbering: assigns 01, 02, ... by visible order of sections
   that carry an .eyebrow > .ch-num element. */
(function () {
  if (!document.querySelector('.eyebrow > .ch-num')) return;

  // Eyebrows mit Kapitelnummer markieren (CSS-Hook statt :has() —
  // :has() macht Style-Recalcs bei App-Widget-Mutationen teuer).
  document.querySelectorAll('.eyebrow > .ch-num').forEach(function (n) {
    n.parentNode.classList.add('has-num');
  });

  var secs = Array.prototype.slice.call(document.querySelectorAll('section'))
    .filter(function (s) { return s.querySelector(':scope .eyebrow > .ch-num'); });
  secs.sort(function (a, b) {
    var oa = parseInt(getComputedStyle(a).order, 10) || 0;
    var ob = parseInt(getComputedStyle(b).order, 10) || 0;
    if (oa !== ob) return oa - ob;
    return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
  });
  secs.forEach(function (s, i) {
    var n = (i + 1 < 10 ? '0' : '') + (i + 1);
    var el = s.querySelector(':scope .eyebrow > .ch-num');
    if (el.textContent !== n) el.textContent = n;
  });
})();

/* Parallax: Bilder mit .k27-plx driften beim Scrollen leicht gegen die
   Scrollrichtung. Mittelpunkt-basiert (Element in Viewport-Mitte = 0px,
   kein Layout-Sprung), nur transform (Compositor), Shift geklemmt;
   scale(1.12) gibt dem Bild Luft, damit keine Raender aufreissen.
   Gated auf prefers-reduced-motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var els = [];
  function collect() {
    els = Array.prototype.slice.call(document.querySelectorAll('.k27-plx'))
      .map(function (el) {
        return { el: el, speed: parseFloat(el.getAttribute('data-plx')) || 0.1 };
      });
  }

  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (o) {
      var r = o.el.getBoundingClientRect();
      if (r.bottom < -120 || r.top > vh + 120) return; /* ausserhalb: nicht anfassen */
      var fromCenter = r.top + r.height / 2 - vh / 2;
      var y = Math.max(-34, Math.min(34, -fromCenter * o.speed));
      o.el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0) scale(1.12)';
    });
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(frame);
  }

  function boot() { collect(); frame(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { collect(); onScroll(); }, { passive: true });
  window.addEventListener('load', onScroll);
})();
